import { CheckBox } from '@mui/icons-material';
import {
  Container, Paper, Link, Tab, Tabs, Box, Input,
  TextField, StepButton, Button, Typography, FormControlLabel,
  Select, MenuItem, FormControl, InputLabel
} from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import * as API from '../../../utils/APICalls'
import * as helpers from '../../../utils/helpers'

// import dayjs from 'dayjs';

// const minBookingDay = dayjs().add(7, 'day');



const BookingForm = ({ setShowDrawer, artist, view }) => {
  var formSteps = [['contact', false], ['event', false], ['booking', false], ['additional', false]]
  const requiredFields = ['name', 'email', 'phone', 'venue', 'city', 'state', 'date',
    'capacity', 'event_time', 'event_type', 'set_time',
    'set_length', 'other_acts', 'budget', 'door_age', 'adv', 'door']

  const contactFields = ['name', 'email', 'phone']
  const locationFields = ['venue', 'city', 'state', 'capacity',]
  const eventTimeFields = ['date', 'event_time',]
  const eventFields = ['event_name', 'host', 'door_age', 'event_type', 'description',]
  const bookingFields = ['set_time', 'set_length', 'other_acts', 'budget']
  const priceFields = ['adv', 'door']
  const additionalFields = ['tech_needs', 'sponsors', 'contract_needs']
  const lengthOptions = ['20-30', '30-45', '45-1hr', '1hr+']
  const budgetOptions = ['other', '< 500', '500-1000', '1000-2500', '2500-5000', '5000+']
  const capacityOptions = ['< 500', '500 - 1,000', '1,000 - 6,000',
    '5,000 - 20,000', '20,000 - 50,000', '50,000 - 120,000+']
  const doorAgeOptions = ['All Ages', '18+', '21+']
  const priceOptions = ['TBD', 'FREE', 'Donations', '5', '10', '15', '20', '25', '30', '35']
  const eventTypeOptions = ['Open Mic', 'Club/Bar Show', 'Concert', 'Festival', 'Showcase', 'Private Party', 'Media Appearance', 'Virtual Event', 'Battle of the Bands', 'Talent Search', 'Charity Event', 'Corporate Event', 'Community Event', 'House Party', 'Wedding', 'Sporting Event', 'School/Uuniversity Event', 'Other'
  ]


  const [currentStep, setCurrentStep] = useState(formSteps[0])
  const [bookingIsDayOf, setBookingIsDayOf] = useState(true)
  const [formData, setFormData] = useState()
  const formRef = useRef()
  const { register, handleSubmit, reset, setValue, getValues, formState: { errors, isSubmitSuccessful }, formState } = useForm({
    defaultValues: {
      artist: artist?._id,
      booking_contact: { name: '', email: '', phone: '' },
      do_contact: { name: '', email: '', phone: '' },
      event_name: '',
      event_type: '',
      host: '',
      location: {
        venue: '',
        city: '',
        state: '',
        capacity: '< 500'
      }
      ,
      door_age: '',
      date: '',
      price: {
        adv: '',
        door: ''
      },
      sponsors: '',
      description: '',
      event_time: '',
      set_time: '',
      set_length: 0, //<--Minutes
      budget: 0,
      tech_needs: '',
      other_acts: '',
      contract_needs: '',
      isInternal: view === 'console' ? true : false
    }
  });

  const naText = '("NA" if not applicable)'
  const [activeStep, setActiveStep] = React.useState(formSteps.indexOf(currentStep));
  const [completed, setCompleted] = React.useState({});
  const [subView, setSubView] = useState()

  const getMinDate = () => {
    const today = new Date();
    const futureDate = new Date(today); // Create a copy to avoid modifying the original
    futureDate.setDate(today.getDate() + 7);
    return futureDate;
  };

  const totalSteps = () => {
    return formSteps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        formSteps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);

  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    setCompleted({
      ...completed,
      [activeStep]: true,
    });
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  const onSubmit = (data) => {
    // data matches your schema structure
    console.log('onSubmit', data);
    setFormData(data)
    // handleNext()
    handleComplete()
  };

  const sendBooking = async () => {
    try {

      const data = await API.createBooking({ ...getValues() })
      if (data) {
        console.log('[sendBooking] data:', data)
        handleReset()
        reset()
        setShowDrawer(false)
      }
    } catch (err) {
      throw new Error('Error sending booking', err)
    }
  }

  const formStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '0.5rem'
  }


  const typeCheck = (key) => {
    if (key?.includes('email')) {
      return 'email'
    }
    if (key?.includes('phone')) {
      return 'phone'
    }
    if (key?.includes('date')) {
      return 'date'
    }
    if (key?.includes('time')) {
      return 'time'
    }
    if (key?.includes('capacity') || key?.includes('budget')) {
      return 'select'
    }
    else {
      return 'text'
    }

  }
  const setSharedContact = () => {
    try {
      setValue("do_contact.name", formData?.booking_contact?.name)
      setValue("do_contact.email", formData?.booking_contact?.email)
      setValue("do_contact.phone", formData?.booking_contact?.phone)

    } catch (err) { console.log('setSharedConact error', err) }
  }
  useEffect(() => {
    if (bookingIsDayOf) {

      setSharedContact()
    }
    // setFormData({
    //   ...formData,
    //   do_contact:{
    //     ...formData?.booking_contact
    //   }
    // })

  }, [bookingIsDayOf])

  useEffect(() => {
    setCurrentStep(formSteps[activeStep])
  }, [activeStep])
  useEffect(() => {

  }, [currentStep])
  //  useEffect(() => {
  //   if (isSubmitSuccessful) {
  //     reset();
  //     setShowDrawer(false)
  //   }
  // }, [isSubmitSuccessful, reset]);

  return (
    <Container style={{ margin: 'auto', height: '100%', width: '100%', textAlign: 'center', alignContent: 'center', alignItems: 'center' }}>
      {/* <Box>
      <Tabs sx={{display:'flex',}}
        textColor= "#00FF00"
        indicatorColor="#00FF00"
        // onChange={(e)=>setWalletView(e.target.value)}
        >

          {formSteps?.map((s,i)=>{
            return(

              <Tab label={s} value={s} 
              sx={{color: currentStep === s? 'magenta':"#00FF00"}}
              onClick={(e)=>setCurrentStep(s)}
              />
            )
          })}
       
                        
        </Tabs>
        </Box> */}
      {/* Under construction. Coming Soon! */}
      <Paper sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%', width: '100%', flex: 1,
        marginTop: '1rem',

        padding: '0.5rem', gap: '0.5', justifyContent: 'center'
      }}>

        <Stepper activeStep={activeStep} alternativeLabel
          sx={{ marginTop: '1rem' }}>
          {formSteps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <form style={formStyles}
          onSubmit={handleSubmit(onSubmit)} ref={formRef}>

          {currentStep[0] === 'contact' && <>
            Booking Contact
            {/* <form style={formStyles} 
        onSubmit={handleSubmit(onSubmit)}> */}

            {contactFields?.map((f, i) => {
              return (
                <>
                  <TextField required={requiredFields?.includes(f)}
                    label={f?.replace(/_/g, ' ')} {...register(`booking_contact.${f}`)}
                    key={i} id={f}
                    type={typeCheck(f)}

                  />
                </>
              )
            })}
            Day of Contact
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', margin: 'auto' }}>

              <FormControlLabel control={<input
                type={'checkbox'}
                checked={bookingIsDayOf}
                id='same-as-booking'
                //   onClick={()=>{
                // setBookingIsDayOf(!bookingIsDayOf)  
                //   }}
                onChange={e => setBookingIsDayOf(e.target.checked)}
              />}
                label="Same as booking contact"
                sx={{ display: 'flex' }}
              />
              {/* <label for={'same-as-booking'}> */}
              {/* Same as booking contact */}
              {/* </label> */}
            </span>
            {!bookingIsDayOf && contactFields?.map((f, i) => {

              return (
                <>
                  <TextField required={requiredFields?.includes(f)}
                    label={f?.replace(/_/g, ' ')} {...register(`do_contact.${f}`)} key={i} id={f}
                    type={typeCheck(f)} />
                </>
              )
            })}
            {/* <button type="submit">Next</button> */}
            {/* </form> */}
            {/* </Box>} */}
          </>}

          {currentStep[0] === 'event' && <>
            Location
            {/* <form style={formStyles} 
        onSubmit={handleSubmit(onSubmit)}> */}

            {locationFields?.map((f, i) => {

              if (f === 'capacity') {
                return (
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">capacity</InputLabel>
                    <Select
                      key={i} id={f}
                      value={getValues("location.capacity",)}
                      label="capacity"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          location: {
                            ...formData?.location,
                            capacity: e.target.value

                          }
                        })
                        setValue("location.capacity", e.target.value)
                        console.log('capacity', formData)
                      }}
                    // {...register(`location.${f}`)} 
                    >
                      {capacityOptions?.map((o, i) => {
                        return (

                          <MenuItem value={o} >{o}</MenuItem>
                        )
                      })}

                    </Select>

                  </FormControl>
                )



              }
              else {
                return (
                  <>
                    <TextField required={requiredFields?.includes(f)}
                      label={f?.replace(/_/g, ' ')} {...register(`location.${f}`)} key={i} id={f}
                      type={typeCheck(f)}

                    />
                  </>
                )
              }
            })}

            {/* <button type="sub
        mit">Next</button> */}
            {/* </form> */}
            {/* <form style={formStyles} 
        onSubmit={handleSubmit(onSubmit)}> */}
            Time
            <Box sx={{ display: 'flex', width: '100%', gap: '0.5rem', margin: 'auto', alignSelf: 'center', justifyContent: 'center' }}>
              {eventTimeFields?.map((f, i) => {
                //  console.log(f?.split(', ' '))

                return (
                  <>
                    <TextField

                      required={requiredFields?.includes(f)}
                      label={f?.replace(/_/g, ' ')} {...register(`${f}`)}
                      key={i} id={f}
                      type={typeCheck(f)}
                      sx={{
                        width: typeCheck(f) === 'date' || typeCheck(f) === 'time' ? '40%' : '100%',

                      }}
                      InputProps={{ inputProps: typeCheck(f) === 'date' ? { min: getMinDate().toISOString().slice(0, 10) } : {} }}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                    />
                  </>
                )
              })}
            </Box>
            Details
            {priceFields?.map((f, i) => {
              return (
                <FormControl fullWidth>
                  <InputLabel id={f}>{f} price</InputLabel>
                  <Select
                    required={requiredFields?.includes(f)}
                    key={i} id={f}
                    value={getValues(`price.${f}`)}
                    label={`${f} price`}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        price: {
                          ...formData.price,
                          [f]: e.target.value
                        }
                      })
                      setValue(`price.${f}`, e.target.value)
                      // console.log('event_type',formData )
                    }}
                  // {...register(`location.${f}`)} 
                  >
                    {priceOptions?.map((o, i) => {
                      return (

                        <MenuItem value={o} >{o}</MenuItem>
                      )
                    })}

                  </Select>

                </FormControl>
              )

            })
            }
            {eventFields?.map((f, i) => {
              //  console.log(f?.split(', ' '))
              if (f === 'event_type') {
                return (
                  <FormControl fullWidth>
                    <InputLabel id={f}>event type</InputLabel>
                    <Select
                      required={requiredFields?.includes(f)}
                      key={i} id={f}
                      value={getValues("event_type")}
                      label="event type"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          event_type: e.target.value
                        })
                        setValue("event_type", e.target.value)
                        // console.log('event_type',formData )
                      }}
                    // {...register(`location.${f}`)} 
                    >
                      {eventTypeOptions?.map((o, i) => {
                        return (

                          <MenuItem value={o} >{o}</MenuItem>
                        )
                      })}

                    </Select>

                  </FormControl>
                )


              }
              if (f === 'door_age') {
                return (
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">door age</InputLabel>
                    <Select
                      required={requiredFields?.includes(f)}
                      key={i} id={f}
                      value={getValues("door_age")}
                      label="door age"
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          door_age: e.target.value
                        })
                        setValue("door_age", e.target.value)
                        //  console.log('door_age',formData )
                      }}
                    // {...register(`location.${f}`)} 
                    >
                      {doorAgeOptions?.map((o, i) => {
                        return (

                          <MenuItem value={o} >{o}</MenuItem>
                        )
                      })}

                    </Select>

                  </FormControl>
                )
              } else {

                return (
                  <>
                    <TextField

                      required={requiredFields?.includes(f)}
                      label={f?.replace(/_/g, ' ')} {...register(`${f}`)}
                      key={i} id={f}
                      type={typeCheck(f)}
                      multiline={typeCheck(f) === 'description'}
                      rows={typeCheck(f) === 'description' ? 3 : 1}
                      minRows={typeCheck(f) === 'description' ? 3 : 1}
                      sx={{
                        width: typeCheck(f) === 'date' || typeCheck(f) === 'time' ? '40%' : '100%',

                      }}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                    />
                  </>
                )
              }
            })}

            {/* <button type="submit">Next</button> */}

            {/* </Box>} */}
          </>}

          {currentStep[0] === 'booking' &&
            //  
            <>
              {/* <form style={formStyles} 
        onSubmit={handleSubmit(onSubmit)}> */}

              {bookingFields?.map((f, i) => {
                //  console.log(f?.split(', ' '))
                if (f === 'set_length') {
                  return (
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Set Length</InputLabel>
                      <Select
                        required
                        key={i} id={f}
                        value={getValues("length")}
                        label="length"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            length: e.target.value

                          })
                          setValue("length", e.target.value)
                          // console.log('length',formData )
                        }}
                      // {...register(`location.${f}`)} 
                      >
                        {lengthOptions?.map((o, i) => {
                          return (

                            <MenuItem value={o} >{o}</MenuItem>
                          )
                        })}

                      </Select>

                    </FormControl>
                  )

                }
                if (f === 'budget') {
                  return (
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Budget</InputLabel>
                      <Select
                        key={i} id={f}
                        value={getValues("budget")}
                        label="budget"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            budget: e.target.value

                          })
                          setValue("budget", e.target.value)
                          // console.log('budget',formData )
                        }}
                      // {...register(`location.${f}`)} 
                      >
                        {budgetOptions?.map((o, i) => {
                          return (

                            <MenuItem value={o} >{o}</MenuItem>
                          )
                        })}

                      </Select>

                    </FormControl>
                  )

                } else {

                  return (
                    <>
                      <TextField required={requiredFields?.includes(f)}
                        label={`${f?.replace(/_/g, ' ')} ${f === 'other_acts' ? '( "NA" if not applicable )' : ''}`} {...register(`${f}`)} key={i} id={f}
                        type={typeCheck(f)}
                        sx={{
                          width: typeCheck(f) === 'date' || typeCheck(f) === 'time' ? '40%' : '100%',

                        }}
                      />
                    </>
                  )
                }
              })}

              {/* <button type="submit">Next</button> */}
              {/* </form> */}
              {/* </Box>} */}
            </>}


          {currentStep[0] === 'additional' && !allStepsCompleted() &&
            //  
            <>
              {/* <form style={formStyles} 
      onSubmit={handleSubmit(onSubmit)}> */}

              {additionalFields?.map((f, i) => {
                //  console.log(f?.split(', ' '))
                return (
                  <>
                    <TextField required={requiredFields?.includes(f)}
                      label={f?.replace(/_/g, ' ')} {...register(`${f}`)} key={i} id={f}
                      type={typeCheck(f)} />
                  </>
                )
              })}

              {/* <button type="submit">Next</button> */}
              {/* </form> */}
              {/* </Box>} */}
            </>}

          <div>
            {allStepsCompleted() && <Typography sx={{ marginTop: '1rem' }}>
              <b>
                All steps coompleted! Click to submit!
              </b>
            </Typography>}
            {allStepsCompleted() ? (
              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, width: '100%', margin: 'auto', marginTop: '1rem', justifyContent: 'space-between' }}>
                <Button
                  color="inherit"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
                {!isLastStep() && <Button type='submit'
                  // onClick={()=>{
                  //   handleNext()

                  // }} 
                  sx={{ mr: 1 }}>
                  Next
                </Button>}
                <Button onClick={sendBooking}
                >
                  Submit
                </Button>
              </Box>
              // <React.Fragment>
              //   <Typography sx={{ mt: 2, mb: 1 }}>
              //     All steps completed - you&apos;re finished
              //   </Typography>
              //   <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              //     <Box sx={{ flex: '1 1 auto' }} />
              //     <Button onClick={handleReset}>Reset</Button>
              //   </Box>
              // </React.Fragment>
            ) : (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1, py: 1 }}>
                  {/* Step {activeStep + 1} */}
                  {/* {activeStep > 2&& formSteps[activeStep][0]} */}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                  <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button>

                  <Box sx={{ flex: '1 1 auto' }} />

                  {completedSteps() !== totalSteps() &&
                    <Button type='submit'
                      // onClick={()=>{
                      //   handleNext()

                      // }} 
                      sx={{ mr: 1 }}>
                      Next
                    </Button>
                  }


                  {/* {activeStep !== formSteps.length &&
                (completed[activeStep] ? (
                  <Typography variant="caption" sx={{ display: 'inline-block' }}>
                    Step {activeStep + 1} already completed
                  </Typography>
                ) : (
                  <Button onClick={handleComplete}>
                    {completedSteps() === totalSteps() - 1
                      ? 'Finish'
                      : 'Complete Step'}
                  </Button>
                ))} */}
                </Box>
              </React.Fragment>
            )}
          </div>
        </form>

      </Paper>
      <Typography sx={{ color: '#00FF00', margin: 'auto', marginTop: '1rem', alignSelf: 'center', fontSize: '0.8rem' }}>( If you have complications contact
        <Link style={{ color: '#FF00FF' }} href="mailto:booking@rexentropy.com">
          &nbsp;{artist?.booking_email}
        </Link> )
      </Typography>
    </Container>
  )
}

export default BookingForm